import React from 'react';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { maxNumberByType } from 'components/ComponentNavigator/jigsaw-limits';
import activeGalleryInstance from './ActiveGalleryInstance';

import './GalleryCheck.scss';

interface GalleryCheck {
  index: number;
}
export const GalleryCheck = observer(function (props: GalleryCheck) {
    const activeGallery = activeGalleryInstance.get();
    const jigsaw = activeGallery ? activeGallery.jigsaw : { type: '', jigsawList: [] as any[] };
    const type = jigsaw.type || '';
    const maximumOfCurrentType = maxNumberByType(type);
    const length = jigsaw.jigsawList ? jigsaw.jigsawList.length : 0;
    const shouldDisabledShow = length >= maximumOfCurrentType;
    const checked = props.index !== -1;
    return (
      // 尝试去掉主题配色，直接使用微信绿，做突出显示 2023-05-30
      <div
        className={classnames({
          'gallery-check': true,
          [checked ? 'checked' : 'unchecked']: true,
          //  下面是后期加的，用于区分不同的类型
          [`checkbox-${type}`]: true,
          //  是否超过了最大数量
          [`checkbox-${type}-exceed`]: shouldDisabledShow,
        })}
        style={
          {
            /*backgroundColor, color: h1Color*/
          }
        }
      >
        {props.index === -1 ? '' : props.index + 1}
      </div>
    );
  });
